import React from 'react';
import {ProfileScreen} from './Profile';
import {Routes} from 'navigation/Routes';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {ScreenWithLayout} from 'components/common/screen-layouts';
import {ResetPasswordScreen} from './ResetPassword';

const ProfileStack = createNativeStackNavigator();

export function ProfileScreenNavigator() {
  return (
    <ProfileStack.Navigator screenOptions={{headerShown: false}}>
      <ProfileStack.Screen name={Routes.VIEW_PROFILE}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <ProfileScreen {...screenProps} mode="view" />
          </ScreenWithLayout>
        )}
      </ProfileStack.Screen>

      <ProfileStack.Screen name={Routes.EDIT_PROFILE}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <ProfileScreen {...screenProps} mode="edit" />
          </ScreenWithLayout>
        )}
      </ProfileStack.Screen>

      <ProfileStack.Screen name={Routes.RESET_PASSWORD}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <ResetPasswordScreen {...screenProps} mode='reset' />
          </ScreenWithLayout>
        )}
      </ProfileStack.Screen>
    <ProfileStack.Screen name={Routes.FORGOT_PASSWORD}>
        {screenProps => (
          <ScreenWithLayout {...screenProps}>
            <ResetPasswordScreen {...screenProps} mode="forgot"/>
          </ScreenWithLayout>
        )}
      </ProfileStack.Screen>
    </ProfileStack.Navigator>
  );
}
